import { NgModule } from '@angular/core';

import { ObjToKeysPipe } from './obj-to-key.pipe';
import { ReversePipe } from './reverse-array.pipe';
import { SanitizeHtmlPipe } from './sanitise-html.pipe';
import { SanitizeResourceUrlPipe } from './sanitise-resource-url.pipe';


const PIPES = [
    ObjToKeysPipe,
    ReversePipe,
    SanitizeHtmlPipe,
    SanitizeResourceUrlPipe
];

@NgModule({
    imports: [],
    declarations: [...PIPES],
    providers: [],
    exports: [...PIPES]
})
export class PipesModule {
}